<div class="download-orders-container">
  <app-download-order
    *ngFor="let order of orders"
    [orderObject]="order"
  ></app-download-order>
</div>
